//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { mapMutations } from 'vuex'
export default {
  name: 'CormackLehane_info',
  data() {
    return {}
  },
  components: {},
  created() {
    this.hideLoad()
  },
  methods: {
    ...mapMutations(['hideLoad']),
  },
}



// WEBPACK FOOTER //
// ./src/pages/formulasInfo/ER/Chart_CormackLehane_info.vue